
import React from 'react';
import { Button } from '@/components/ui/button';
import { Heart, BookmarkIcon } from 'lucide-react';

interface VideoActionButtonsProps {
  isFavorite: boolean;
  isInPlaylist: boolean;
  onToggleFavorite: () => void;
  onOpenPlaylistDialog: () => void;
}

const VideoActionButtons = ({ 
  isFavorite, 
  isInPlaylist,
  onToggleFavorite, 
  onOpenPlaylistDialog 
}: VideoActionButtonsProps) => {
  return (
    <div className="absolute top-2 right-2 flex flex-col gap-2 z-10">
      <Button
        size="icon"
        variant="secondary"
        className="w-8 h-8 bg-black/70 hover:bg-black/90 rounded-full transition-all duration-200"
        onClick={onToggleFavorite}
        title={isFavorite ? "Retirer des favoris" : "Ajouter aux favoris"}
      >
        <Heart className={`h-4 w-4 ${isFavorite ? 'fill-youtube-red text-youtube-red' : 'text-white'}`} />
      </Button>
      
      <Button
        size="icon" 
        variant="secondary"
        className="w-8 h-8 bg-black/70 hover:bg-black/90 rounded-full transition-all duration-200"
        onClick={onOpenPlaylistDialog}
        title={isInPlaylist ? "Gérer les playlists" : "Ajouter à une playlist"}
      >
        <BookmarkIcon className={`h-4 w-4 ${isInPlaylist ? 'fill-youtube-red text-youtube-red' : 'text-white'}`} />
      </Button>
    </div>
  );
};

export default VideoActionButtons;
